"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.orientation = exports.deviceMax = exports.device = void 0;
// SiteGlass Device Sizes
// This is an augmented and expanded list that uses the
// UXCore Grid breakpoints
const size = exports.size = {
  mobileSm: 320,
  // Nuanced mobile sizes, it's important that we can have these to better target smaller screens
  mobile: 375,
  // Nuanced mobile sizes, it's important that we can have these to better target smaller screens
  mobileLg: 520,
  tablet: 768,
  tabletLg: 992,
  ipadPro: 1024,
  laptop: 1200,
  laptopMd: 1280,
  mostCommon: 1366,
  laptopLg: 1440,
  desktopSm: 1720,
  desktop: 1920,
  desktopLg: 2360
};

// SiteGlass breakpoint mixins
const device = exports.device = {
  mobileSm: `(min-width: ${size.mobileSm}px)`,
  /*  320 */
  mobile: `(min-width: ${size.mobile}px)`,
  /*  375 */
  mobileLg: `(min-width: ${size.mobileLg}px)`,
  /*  520 */
  tablet: `(min-width: ${size.tablet}px)`,
  /*  768 */
  tabletLg: `(min-width: ${size.tabletLg}px)`,
  /*  992 */
  ipadProVmin: `(min-width: ${size.ipadPro}px)`,
  /* 1024 */
  laptop: `(min-width: ${size.laptop}px)`,
  /* 1200 */
  laptopMd: `(min-width: ${size.laptopMd}px)`,
  /* 1280 */
  mostCommon: `(min-width: ${size.mostCommon}px)`,
  /* 1366 */
  laptopLg: `(min-width: ${size.laptopLg}px)`,
  /* 1440 */
  desktopSm: `(min-width: ${size.desktopSm}px)`,
  /* 1720 */
  desktop: `(min-width: ${size.desktop}px)`,
  /* 1920 */
  desktopLg: `(min-width: ${size.desktopLg}px)` /* 2360 */
};
const deviceMax = exports.deviceMax = {
  mobileSm: `(max-width: ${size.mobile - 1}px)`,
  /*  374 */
  mobile: `(max-width: ${size.mobileLg - 1}px)`,
  /*  519 */
  mobileLg: `(max-width: ${size.tablet - 1}px)`,
  /*  767 */
  tablet: `(max-width: ${size.tabletLg - 1}px)`,
  /*  991 */
  tabletLg: `(max-width: ${size.laptop - 1}px)`,
  /* 1199 */
  laptopSm: `(max-width: ${size.laptopMd - 1}px)`,
  /* 1279 */
  laptop: `(max-width: ${size.mostCommon - 1}px)`,
  /* 1365 */
  mostCommon: `(max-width: ${size.laptopLg - 1}px)`,
  /* 1439 */
  laptopLg: `(max-width: ${size.desktopSm - 1}px)`,
  /* 1719 */
  desktopSm: `(max-width: ${size.desktop - 1}px)`,
  /* 1919 */
  desktop: `(max-width: ${size.desktopLg - 1}px)` /* 2359 */
};
const orientation = exports.orientation = {
  portrait: '(orientation: portrait)',
  landscape: '(orientation: landscape)'
};